<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <path d="M3 11v2a1 1 0 0 0 1 1h2l7 4V6l-7 4H4a1 1 0 0 0-1 1z" />
    <path d="M14 9.5a4 4 0 0 1 0 5" />
    <path d="M16 7.5a7 7 0 0 1 0 9" />
  </svg>
</template>

<script>
export default {
  name: 'IconMegaphone',
  props: { className: { type: String, default: 'w-5 h-5' } },
}
</script>

